import { ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useContratoOperadoraService } from "@services/ContratoOperadoraService";
import React from "react";
import { IEmpresa } from "./Empresa";
import { IOperadora } from "./Operadora";

export interface IContratoOperadora {
    contratoOperadoraId: number

    operadoraId: number
    empresaId: number
    contratoOperadoraStatusId: number

    referencia: string
    inicio: Date
    termino?: Date
    notas?: string

    empresaNome: string
    operadoraNome: string
    contratoOperadoraStatusNome: string

    empresa: IEmpresa
    operadora: IOperadora
}

export type IComboContratoOperadora = ISpecializedCombo<IContratoOperadora>;

export function useContratoOperadoraCombo (initialValue?: number) : IComboContratoOperadora {
    const combo = useCombo<IContratoOperadora>({
        value: initialValue
    });

    const contratoOperadoraService = useContratoOperadoraService();

    const createOptions = React.useCallback(() => {
        return combo.set.map((contratoOperadora, index) => {
            return <MenuItem key={index} value={contratoOperadora.contratoOperadoraId}>{`${contratoOperadora.empresaNome} - ${contratoOperadora.operadoraNome}`}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(contratoOperadoraService.listarAtivos)
    }, [combo, contratoOperadoraService.listarAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}